function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var _excluded = ["children"],
  _excluded2 = ["mode", "children"];
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useContext, useImperativeHandle } from 'react';
import { Form as AntForm, ConfigProvider } from 'antd';
import { Text } from "./Text";
import { jsx as _jsx } from "react/jsx-runtime";
export var FormContext = /*#__PURE__*/React.createContext({
  mode: 'edit',
  form: null
});
var FormField = function FormField(props) {
  var _elements$;
  var children = props.children,
    rest = _objectWithoutProperties(props, _excluded);
  var _props$required = props.required,
    required = _props$required === void 0 ? false : _props$required;
  var context = useContext(FormContext);
  var element;
  if (typeof children === 'function') {
    element = function element(form) {
      return children(form, context.mode);
    };
    if (context.mode === 'view') {
      required = false;
    }
  } else {
    var elements = React.Children.toArray(children);
    if (elements.length) {
      switch (context.mode) {
        case 'edit':
          element = elements[0];
          break;
        case 'view':
          element = (_elements$ = elements[1]) !== null && _elements$ !== void 0 ? _elements$ : /*#__PURE__*/_jsx(Text, {});
          required = false;
          break;
      }
    }
  }
  return /*#__PURE__*/_jsx(AntForm.Item, _objectSpread(_objectSpread({}, rest), {}, {
    required: required,
    children: element
  }));
};
var InternalForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var mode = props.mode,
    children = props.children,
    rest = _objectWithoutProperties(props, _excluded2);
  var _AntForm$useForm = AntForm.useForm(),
    _AntForm$useForm2 = _slicedToArray(_AntForm$useForm, 1),
    form = _AntForm$useForm2[0];
  useImperativeHandle(ref, function () {
    return {
      form: form
    };
  });
  return /*#__PURE__*/_jsx(ConfigProvider, {
    theme: mode === 'view' ? {
      components: {
        Form: {
          itemMarginBottom: 10
        }
      }
    } : undefined,
    children: /*#__PURE__*/_jsx(FormContext.Provider, {
      value: {
        form: rest.form || form,
        mode: mode
      },
      children: /*#__PURE__*/_jsx(AntForm, _objectSpread(_objectSpread({
        form: form
      }, rest), {}, {
        children: children
      }))
    })
  });
});
export var Form = InternalForm;
Form.Field = FormField;
Form.Item = AntForm.Item;
Form.List = AntForm.List;
Form.ErrorList = AntForm.ErrorList;
export default Form;